<template lang="pug">
#PartsList
  div(style="display: flex; justify-content: end; gap: 8px;")
    b-button.mb-3(variant="button" :href="fileUrl" download align-self="end" class="d-none d-md-flex")
      b-icon.mr-1(icon="cloud-download" variant="ligth")
      | Descargar Plantilla
    b-button.mb-3(variant="button" @click="exportExcel()" :disabled="loadingExport" :loading="loadingExport" align-self="end" class="d-none d-md-flex border border-2")
      b-icon.mr-1(icon="file-earmark-arrow-down-fill" variant="ligth")
      | Exportar Excel
  .container-list
    b-card(border-variant="light")
      strong Ingresar Búsqueda
      b-row
        b-col(md="6" sm="12")
          b-input-group.mt-2
            b-input-group-prepend
              b-button(@click="handleSearch" variant="light")
                b-icon(icon="search" variant="muted" size="md")
            b-form-input(
              v-model="search"
              placeholder="Ingresar el Código de la Pieza / Descripción / Ubicación Real"
              @keydown.enter="handleSearch"
              @keydown.esc="handleClear"
            )
            b-input-group-append
              b-button(@click="handleClear" variant="light")
                b-icon(icon="x" variant="muted" size="md")
        b-col(md="6" sm="12" class="d-sm-block d-md-none mt-2")
          b-dropdown(text="Opciones" variant="primary"   right)
            b-dropdown-item(:href="fileUrl" download)
              b-icon.mr-1(icon="cloud-download" variant="ligth")
              | Descargar Plantilla
            b-dropdown-item(@click="exportExcel()" :disabled="loadingExport" :loading="loadingExport")
              b-icon.mr-1(icon="file-earmark-arrow-down" variant="ligth")
              | Exportar Excel
            b-dropdown-item(@click="$bvModal.show('create-edit-modal')")
              b-icon.mr-1(icon="plus" variant="ligth")
              |  Crear nueva pieza
            b-dropdown-item(@click="$bvModal.show('file-modal')")
              b-icon.mr-1(icon="file-earmark-arrow-up-fill" variant="ligth")
              |  Carga Masiva
        b-col.d-flex.justify-content-end(md="6" sm="12")
          //- Crear/Editar Parte
          b-button.mt-2(variant="estado-green" v-b-modal.create-edit-modal class="d-none d-md-flex") + Crear Nueva Pieza
          b-modal#create-edit-modal(:title="form.id ? 'Editar pieza' : 'Crear Nueva Pieza'" hide-footer ref="createmodal" @hidden="triggerCloseCreateModal")
            .col-10
              label.label Código de la Pieza
              b-form-input(v-model="form.part_number", placeholder="Ingrese Código de la Pieza", :state="$v.$dirty ? !$v.form.part_number.$invalid : null")
              .errors(v-if="$v.$dirty")
                b-form-invalid-feedback(:state="$v.form.part_number.required") Campo requerido
            .col-10
              label.label Costo
              b-form-input(
                v-model="form.costo",
                type="number",
                placeholder="Ingrese Costo",
                :state="$v.$dirty ? !$v.form.costo.$invalid : null"
              )
            .col-10
              label.label Descripción
              b-form-input(v-model="form.description", placeholder="Ingrese Descripción", :state="$v.$dirty ? !$v.form.description.$invalid : null")
              .errors(v-if="$v.$dirty")
                b-form-invalid-feedback(:state="$v.form.description.required") Campo requerido
            .col-10
              label.label Grupo
              b-form-select(v-model="form.group", :options="partGroups", value-field="id", text-field="description")
                template(#first)
                  b-form-select-option(:value="null") -- Sin grupo --
            .col-10
              label.label Ubicación Real
              b-form-input(v-model="form.real_location", placeholder="Ingrese Ubicación Real", :state="$v.$dirty ? !$v.form.real_location.$invalid : null")
              .errors(v-if="$v.$dirty")
                b-form-invalid-feedback(:state="$v.form.real_location.required") Campo requerido
            .col-12.d-flex.justify-content-around.mt-4
              b-button.modal-btn(variant="outline-danger" @click="$bvModal.hide('create-edit-modal')") Cancelar
              b-button.modal-btn(variant="button" @click="createOrEditPart()" :disabled="loading") {{ form.id ? 'Editar' : 'Crear' }}
          //- Carga Masiva
          b-button.ml-2.mt-2(variant="button" v-b-modal.file-modal class="d-none d-md-flex")
            b-icon.mr-1(icon="file-earmark-arrow-up-fill" variant="ligth")
            |  Carga Masiva
          b-modal#file-modal(title="Carga Masiva" hide-footer centered @hidden="file = null")
            .text-center.mb-3
              b-icon(icon="exclamation-triangle-fill" variant="danger" font-scale="3")
              h5.text-danger.mt-2.font-weight-bold Advertencia:
              p.text-muted
                | La carga masiva puede actualizar piezas existentes cuando el
                strong  Part Number
                |  ya se encuentre registrado.
            label.font-weight-bold Selecciona un archivo .xlsx
            .file-selected-box.p-3.mb-4.d-flex.align-items-center.justify-content-between.border.rounded(v-if="file" style="border-style: dashed !important; border-color: #ccc;")
              .d-flex.align-items-center
                b-icon.mr-2(icon="file-earmark-excel-fill" variant="success" font-scale="1.5")
                span.font-weight-bold {{ file.name }}
              b-icon.cursor-pointer(icon="trash-fill" variant="danger" @click="file = null" style="cursor: pointer;")
            .dropzone-container.position-relative.text-center.p-4.mb-4.border.rounded(
              v-else
              style="border-style: dashed !important; border-color: #ccc; background-color: #f8f9fa;"
            )
              b-icon.mb-3(icon="cloud-upload-fill" variant="warning" font-scale="3")
              p.mb-3.text-muted Arrastra el archivo o haz click aquí
              b-button(variant="button") Subir Archivos
              b-form-file.position-absolute.w-100.h-100(
                v-model="file"
                accept=".xlsx, .xls, .csv"
                plain
                style="top: 0; left: 0; opacity: 0; cursor: pointer;"
              )
            .d-flex.justify-content-between
              b-button(variant="light" @click="$bvModal.hide('file-modal')") Cancelar
              b-button(variant="button" @click="handleFileUpload" :disabled="!file") Cargar
  b-table(
    :items="parts",
    :fields="fields",
    head-row-variant="light-primary",
    thead-class="text-black tabla-thead",
    tbody-class="tabla-tbody",
    tbody-tr-class="bg-white",
    responsive,
    :busy="loading",
    show-empty,
    empty-text="Sin datos en lista de partes"
  )
    template(#cell(ultimo_precio)='data')
      span {{ data.item.ultimo_precio > 0 ? '$' + data.item.ultimo_precio.toLocaleString('es-CL') : '—' }}
    template(#cell(actions)='value')
      b-button(variant="link" @click="getPartDetail(value.item.id)" v-b-modal.create-edit-modal)
        b-icon.mr-1(icon="pencil-square")
      //- b-button(variant="link" @click="handleDeleteRow(value.item.id, value.item.part_number)" v-b-modal.delete-modal)
      //-   b-icon.mr-1(icon="trash-fill" variant="danger")
  b-pagination(
    v-model="currentPage",
    :total-rows="count",
    prev-text="Ant.",
    next-text="Sig.",
    @change="handlePageChange"
  )
  b-modal#delete-modal(title="Eliminar Pieza" ok-title="Eliminar" @ok="deletePart(form.id)" @hidden="triggerCloseCreateModal")
    label ¿Desea eliminar pieza {{ partSelected }}?
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

const basePath = process.env.VUE_APP_SERVER_BASE || 'https://center.samtek.cl'

export default {
  name: 'PartsList',
  validations: {
    form: {
      part_number: { required },
      description: { required },
      real_location: { required },
    },
  },
  data() {
    return {
      parts: [],
      partGroups: [],
      currentPage: 1,
      count: 0,
      idUpdating: null,
      loading: false,
      file: null,
      search: '',
      partSelected: '',
      fileUrl: `${basePath}/plantilla_creacion.xlsx`,
      form: {
        id: null,
        part_number: '',
        normalized_part_number: '',
        description: '',
        real_location: '',
        group: null,
      },
      fields: [
        { key: 'part_number', label: 'Código', sortable: true },
        { key: 'real_location', label: 'Ubicación real', sortable: true },
        { key: 'description', label: 'Descripción', sortable: true },
        { key: 'part_group_description', label: 'Grupo', sortable: true },
        { key: 'costo', label: 'Costo', sortable: true },
        { key: 'ultimo_precio', label: 'Último precio venta', sortable: true },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center',
        },
      ],
      loadingExport: false,
    }
  },
  computed: {
    ...mapGetters('PartsStore', ['part']),
  },
  methods: {
    ...mapActions('PartsStore', [
      'listParts',
      'savePartsExcel',
      'createPart',
      'patchPart',
      'removePart',
      'retrievePart',
      'exportPartsExcelToEmail',
      'listPartGroups',
    ]),
    async fetchData(page = 1) {
      this.loading = true
      const resp = await this.listParts({ page, search: this.search })
      this.parts = resp.results
      this.count = resp.count
      this.loading = false
    },
    async getPartDetail(pk) {
      await this.retrievePart({ pk })
      this.form.id = this.part.parte.id
      this.form.part_number = this.part.parte.part_number
      this.form.real_location = this.part.parte.real_location
      this.form.description = this.part.parte.description
      this.form.costo = this.part.parte.costo
      this.form.precio_unitario = this.part.parte.precio_unitario
      this.form.group = this.part.parte.part_group
    },
    handleDeleteRow(id, part) {
      this.partSelected = part
      this.form.id = id
    },
    handleSearch() {
      this.fetchData(this.currentPage)
    },
    handlePageChange(page) {
      this.fetchData(page)
    },
    async deletePart(pk) {
      await this.removePart({ pk })
      this.$bvModal.hide('delete-modal')
      this.fetchData(this.currentPage)
      this.$bvToast.toast('Parte eliminada correctamente.', {
        variant: 'success',
      })
    },
    handleClear() {
      this.search = ''
      this.fetchData(this.currentPage)
    },
    async handleFileUpload() {
      const file_data = new FormData()
      file_data.append('file', this.file)
      const response = await this.savePartsExcel(file_data)
      if (response.status === 200) {
        this.$bvToast.toast('Partes ingresadas.', {
          variant: 'success',
        })
        this.$bvModal.hide('file-modal')
        this.fetchData(this.currentPage)
      } else {
        this.$bvToast.toast(response.data, {
          variant: 'danger',
        })
      }
    },
    async createOrEditPart() {
      this.loading = true
      const action = this.form.id ? this.patchPart : this.createPart
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.form.normalized_part_number = this.form.part_number
        // Excluir precio_unitario del payload
        const { precio_unitario, ...dataToSend } = this.form
        const resp = await action(dataToSend)
        if (resp.status === 201 || resp.status === 200) {
          this.$bvToast.toast(
            this.form.id
              ? 'Se ha editado exitósamente'
              : 'Se ha creado exitósamente',
            {
              variant: 'success',
            }
          )
          this.$bvModal.hide('create-edit-modal')
          this.fetchData(this.currentPage)
        } else {
          this.$bvToast.toast(
            resp.data.detail
              ? resp.data.detail
              : 'Ha ocurrido un error al realizar la operación',
            {
              variant: 'danger',
            }
          )
        }
      }
      this.loading = false
    },
    triggerCloseCreateModal() {
      this.form.id = null
      this.form.part_number = ''
      this.form.description = ''
      this.form.real_location = ''
      this.form.costo = null
      this.form.precio_unitario = null
      this.form.group = null
    },
    async exportExcel() {
      try {
        this.loadingExport = true
        const response = await this.exportPartsExcelToEmail()
        this.$bvToast.toast(
          response.data.message ||
            'El archivo será enviado a su correo electrónico.',
          {
            variant: 'success',
            title: 'Exportación Exitosa',
            autoHideDelay: 5000,
          }
        )
      } catch (error) {
        this.$bvToast.toast(error.data || 'No se pudo exportar el archivo.', {
          variant: 'danger',
          title: 'Error',
          autoHideDelay: 7000,
        })
      } finally {
        this.loadingExport = false
      }
    },
  },
  async created() {
    this.fetchData()
    this.partGroups = await this.listPartGroups()
  },
}
</script>
<style lang="scss">
#PartsList {
  .search-btn {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
  .btn-ingreso {
    width: 130px;
    color: black !important;
    font-weight: bold !important;
    font-size: 14px !important;
    align-items: center;
    opacity: 0.7;
  }
}
#create-edit-modal {
  .col-10 {
    margin-top: 16px;
  }
  label {
    font-weight: bold;
  }
  .label {
    letter-spacing: 0px;
    color: #74788d;
    opacity: 1;
  }
  .modal-btn {
    width: 120px;
    height: 50px;
  }
}
.dropdown-menu.show {
  margin-left: 35px;
}
</style>
